export const phases = [
  { id: "phase-1", name: "Phase 1", description: "XYZ Livin Series" },
  { id: "phase-2", name: "Phase 2 - Zen Series", description: "Modern Zen Living" },
  { id: "phase-3", name: "Phase 3 - 9en Collection", description: "Premium Collection" },
  { id: "phase-4", name: "Phase 4 - Funtastic Four", description: "Family Living" },
  { id: "phase-5", name: "Phase 5 - Hi5 Collection", description: "Contemporary Homes" },
  { id: "phase-6", name: "Phase 6 - Enamaste Collection", description: "Luxury Series" },
  { id: "commercials", name: "Commercials", description: "Commercial Properties" },
];
